"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMessageSelected = useIsMessageSelected;
const react_1 = require("react");
const MessagePanelActionsContext_1 = require("../context/MessagePanelActionsContext");
const noop = () => { };
function useIsMessageSelected(messageId) {
    const { subscribeToMessageSelection, isMessageSelectedById } = (0, react_1.useContext)(MessagePanelActionsContext_1.MessagePanelActionsContext);
    // Some screens render MessageItem read-only, with no MessagePanelProvider
    // ancestor (e.g. MessageInfo, AskForAcknowledgement) — degrade to
    // "never selected" there instead of crashing, matching how the old
    // selectedMessages?.some(...) check degraded gracefully.
    const subscribe = (0, react_1.useCallback)((listener) => subscribeToMessageSelection
        ? subscribeToMessageSelection(messageId, listener)
        : noop, [subscribeToMessageSelection, messageId]);
    const getSnapshot = (0, react_1.useCallback)(() => (isMessageSelectedById ? isMessageSelectedById(messageId) : false), [isMessageSelectedById, messageId]);
    return (0, react_1.useSyncExternalStore)(subscribe, getSnapshot);
}
